module.exports = __webpack_public_path__ + "static/media/NoImageAvailable.4f4a8afc.png";